export default __webpack_public_path__ + "static/media/047.fb5e7b8a.jpg";